'use client'
// apps/hyperseguros-web/src/components/GoogleAnalytics/SubdomainClickTracker.tsx

import { useEffect } from 'react'
import { isSiblingSubdomain } from './isSiblingSubdomain'
import { trackEvent } from './track'

/**
 * GA4 enhanced measurement ignores links to sibling subdomains (they share the
 * site's cookie domain), so send the same `click` outbound event for them.
 * Renders nothing; never prevents the navigation.
 */
export default function SubdomainClickTracker({
  pageHost,
}: {
  pageHost?: string
}) {
  useEffect(() => {
    const onClick = (event: MouseEvent) => {
      const target = event.target
      if (!(target instanceof globalThis.Element)) return
      const anchor = target.closest('a[href]') as HTMLAnchorElement | null
      if (!anchor) return
      const host = pageHost ?? globalThis.location.hostname
      let url: URL
      try {
        url = new URL(anchor.href, globalThis.location.href)
      } catch {
        return
      }
      if (!/^https?:$/.test(url.protocol)) return
      if (!isSiblingSubdomain(url.hostname, host)) return
      trackEvent('click', {
        link_url: url.href,
        link_domain: url.hostname,
        link_text: (anchor.textContent ?? '').trim().slice(0, 100),
        link_id: anchor.id,
        link_classes: anchor.className,
        outbound: true,
        transport_type: 'beacon',
      })
    }
    globalThis.document.addEventListener('click', onClick, true)
    return () => globalThis.document.removeEventListener('click', onClick, true)
  }, [pageHost])
  return null
}
